<template>
  <v-card class="mt-6">
    <v-card-title>
      API de envio via WhatsApp
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12">
          <v-select
            :value="config.whats_provider"
            :items="whatsProviders"
            item-text="text"
            item-value="value"
            outlined
            label="Provedor WhatsApp"
            hint="Selecione qual API de WhatsApp utilizar"
            persistent-hint
            @input="updateField('whats_provider', $event)"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-text-field
            :value="config.whats_endpoint"
            outlined
            label="URL API"
            @input="updateField('whats_endpoint', $event)"
          />
        </v-col>
        <v-col>
          <v-text-field
            :value="config.whats_instance"
            outlined
            label="Instância"
            @input="updateField('whats_instance', $event)"
          />
        </v-col>
        <v-col>
          <v-text-field
            :value="config.whats_key"
            type="password"
            outlined
            label="API KEY"
            @input="updateField('whats_key', $event)"
          />
        </v-col>
      </v-row>
      <v-row no-gutters>
        <v-col>
          <v-textarea
            :value="config.whats_greeting"
            rows="3"
            outlined
            label="Mensagem de saudação"
            @input="updateField('whats_greeting', $event)"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col class="col-8">
          <v-alert
            :type="whats.connected ? 'success' : 'error'"
            dense
            text
          >
            <v-icon left>
              {{ whats.connected ? 'mdi-check-circle' : 'mdi-alert-circle' }}
            </v-icon>
            <strong>Status:</strong> {{ whats.connected ? 'Conectado' : 'Desconectado' }}
          </v-alert>
        </v-col>

        <v-col class="d-flex align-center justify-center">
          <v-btn
            v-if="!whats.connected"
            color="primary"
            :loading="loadingQr"
            @click="$emit('connect')"
          >
            Conectar
          </v-btn>

          <v-btn
            v-else
            color="error"
            :loading="loadingQr"
            @click="$emit('disconnect')"
          >
            Desconectar
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <!-- Modal QR Code -->
    <v-dialog
      :value="showQr"
      max-width="400"
      @input="$emit('update:showQr', $event)"
    >
      <v-card>
        <v-card-title class="justify-center">
          QR Code:
        </v-card-title>

        <v-card-text class="d-flex justify-center">
          <v-img
            v-if="whats.qr"
            :src="whats.qr"
            max-width="250"
            class="mx-auto my-4"
          />
          <div
            v-else
            class="text-caption text-grey"
          >
            QR code não disponível
          </div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="$emit('refresh-qr')"
          >
            Atualizar
          </v-btn>
          <v-btn
            text
            @click="$emit('update:showQr', false)"
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
export default {
  name: 'WhatsAppSettings',
  props: {
    config: {
      type: Object,
      required: true,
    },
    whats: {
      type: Object,
      required: true,
    },
    showQr: {
      type: Boolean,
      default: false,
    },
    loadingQr: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      whatsProviders: [
        { text: 'Evolution API', value: 'evolution' },
        { text: 'Wuzapi', value: 'wuzapi' },
      ],
    }
  },
  methods: {
    updateField(field, value) {
      this.$emit('update', { [field]: value })
    },
  },
}
</script>
